module.exports = __webpack_public_path__ + "img/Jose-Maria-Salas.8091b767.jpg";